import { useState, useEffect } from "react";
import { Dialog } from "@mui/material";
import I18n from "common/i18n";
import { useScale } from "common/utils";
import { getBodyFont } from "common/utils/font";
import { LevelClearIcon } from "features/courses/assets";

type Props = {
  onRetry: () => void;
  onNext: () => void;
};

export const Success = ({ onRetry, onNext }: Props) => {
  const { scale } = useScale();
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    setDisable(false);
  }, []);

  const handleRetry = () => {
    if (!disable) {
      setDisable(true);
      onRetry();
    }
  };

  const handleNext = () => {
    if (!disable) {
      setDisable(true);
      onNext();
    }
  };

  return (
    <Dialog
      open
      fullScreen
      componentsProps={{
        backdrop: { style: { backgroundColor: "transparent" } },
      }}
      sx={{ zIndex: 10001, backgroundColor: "transparent" }}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center !absolute w-full h-full bg-white/70">
        <div className="flex-col-center" style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-center animate-fade-in gap-8">
            <div className="flex-col-view w-[696px] h-[264px]">
              <LevelClearIcon />
            </div>
            <div className="flex-col-view">
              <svg width={608} height={60} viewBox="0 0 608 60">
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="central"
                  fill="#3F4A61"
                  fontSize="32"
                  fontFamily={getBodyFont()}
                  stroke="#FEFDFE"
                  strokeWidth={8}
                  paintOrder="stroke"
                >
                  {I18n.t("MSG_COURSE_GAME_SUCCESS_TEXT")}
                </text>
              </svg>
            </div>

            <div className="flex-row-el flex-center gap-8 alpha">
              <button className="btn btn-blue type-inherit-font" onClick={handleRetry}>
                <p className="text-body text-white type-body">
                  {I18n.t("MSG_COURSE_GAME_SUCCESS_REVIEW_BTN")}
                </p>
              </button>

              <button className="btn btn-primary type-inherit-font" onClick={handleNext}>
                <p className="text-body text-white type-body">
                  {I18n.t("MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN")}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
